<template>
  <div class="pt-10 2xl:pt-14 pb-28"> 
    <div class="flex justify-end px-5 mb-4">
        <RouterLink
          :to="`/applicants/${professionalSlug}`"
          class="rounded-full py-2 px-7 font-medium bg-sea-serpent text-white"
          >Ver perfil</RouterLink
        >
    </div>

      <DisplayCurriculumHeader :professional-data="curriculumData.professional" />
 
      <!-- Seção Apresentação -->
      <DisplayCurriculumPresentation :presentations="curriculumData.presentations" />
  
      <!--  seção Informação completa -->
      <section class="grid grid-cols-1 lg:grid-cols-4 gap-3 px-5 lg:container lg:mx-auto">
        <div class="lg:col-span-4 flex flex-wrap md:flex-nowrap md:gap-x-3">
          <!--  seção idioma -->
          <section class="w-full md:w-1/3">
          <DisplayCurriculumLanguages 
              :idioms="{
                idioms: curriculumData.languages,
                curriculum: curriculumData.curriculum
              }" 
            />

          <DisplayCurriculumSkills 
              :skills="{
                skills: curriculumData.skills,
                curriculum: curriculumData.curriculum
              }" 
            />

            <DisplayCurriculumAdditionalInfo 
              :add-information="{
                addinfo: curriculumData.additional_information,
                curriculum: curriculumData.curriculum
              }" 
            />

            <DisplayCurriculumGraduation :educations="{
                educations: curriculumData.educations,
                curriculum: curriculumData.curriculum
              }" />
          </section>

          <!-- seção Experiência -->
          <section class="w-full md:w-2/3">
            <DisplayCurriculumExperiences
              :experiences="{
                experiences: curriculumData.experiences,
                curriculum: curriculumData.curriculum
              }"
            />
          
          
          </section> 
        </div>
    </section>
  </div>
</template>

<script setup>
  import { onBeforeMount, ref } from "vue" 
  import { RouterLink } from "vue-router";
  import requestHandler from "@/composables/requestHandler"; 
  import DisplayCurriculumGraduation from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumGraduation";   
  import DisplayCurriculumPresentation from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumPresentation"; 
  import DisplayCurriculumExperiences from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumExperiences";   
  import DisplayCurriculumAdditionalInfo from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumAdditionalInfo.vue";   
  import DisplayCurriculumHeader from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumHeader.vue";
  import DisplayCurriculumSkills from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumSkills.vue";
  import DisplayCurriculumLanguages from "@/components/Dashboard/Applicant/DisplayCurriculum/DisplayCurriculumLanguages.vue";

import store from "@/store";


  // ############ Declaração de variáveis ############

  let curriculumData = ref({})
  let professionalSlug = ref('')

  async function getCurriculumData() {
    const response = await requestHandler.executeRequest("/api/curriculum",{},"get")

    if (response.success) {
      curriculumData.value = response.data
      professionalSlug.value = store.getters.getProfessional.professional_slug
    }
  }


  async function relatedProfissionals() {
    
  }

  // ############ Ciclos de Vida/Hooks ############

  onBeforeMount(() => {
    getCurriculumData()
    relatedProfissionals()
  })
</script>

<style scoped>
</style>
